import { render, staticRenderFns } from "./table72.vue?vue&type=template&id=2aafd354&scoped=true&"
import script from "./table72.vue?vue&type=script&lang=js&"
export * from "./table72.vue?vue&type=script&lang=js&"
import style0 from "./table72.vue?vue&type=style&index=0&id=2aafd354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aafd354",
  null
  
)

export default component.exports